import { jsPDF } from "jspdf";

export const A4_MM = { width: 210, height: 297 };

/**
 * Create a jsPDF document with consistent defaults for the app.
 */
export function createDoc(options = {}) {
  const {
    orientation = "p",
    unit = "mm",
    format = "a4",
    compress = true,
  } = options;

  const doc = new jsPDF({ orientation, unit, format, compress });
  doc.setFont("helvetica", "normal");
  return doc;
}


